import { format as fmtDate, formatDistanceToNow, type Locale } from 'date-fns'
import { cs } from 'date-fns/locale/cs'
import { enUS } from 'date-fns/locale/en-US'
import { useI18n } from 'vue-i18n'

const localeMap: Record<string, Locale> = {
    cs,
    en: enUS
}

export function useFormatters() {
    const { locale } = useI18n()

    function getLocale(): Locale {
        return localeMap[locale.value] ?? cs
    }

    function date(value: string | Date | null | undefined, pattern = 'dd. MM. yyyy'): string {
        if (!value) return '—'
        const d = typeof value === 'string' ? new Date(value) : value
        if (isNaN(d.getTime())) return '—'
        return fmtDate(d, pattern, { locale: getLocale() })
    }

    function dateTime(value: string | Date | null | undefined): string {
        return date(value, 'dd. MM. yyyy HH:mm')
    }

    function relative(value: string | Date | null | undefined): string {
        if (!value) return '—'
        const d = typeof value === 'string' ? new Date(value) : value
        if (isNaN(d.getTime())) return '—'
        return formatDistanceToNow(d, { addSuffix: true, locale: getLocale() })
    }

    function number(value: number | null | undefined, opts?: Intl.NumberFormatOptions): string {
        if (value === null || value === undefined || isNaN(value)) return '—'
        return new Intl.NumberFormat(locale.value === 'cs' ? 'cs-CZ' : 'en-US', opts).format(value)
    }

    function currency(value: number | null | undefined, currencyCode = 'CZK'): string {
        return number(value, { style: 'currency', currency: currencyCode })
    }

    return { date, dateTime, relative, number, currency }
}
